var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.343,
    height: 14.142,
    viewBox: "0 0 12.343 14.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_12._Settings",
    "data-name": "12. Settings",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 0.244, 10.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1694",
    "data-name": "Trazado 1694",
    d: "M11.9,3.664H7.157A2.731,2.731,0,0,1,2,3.664H.916a.916.916,0,0,1,0-1.831H2a2.731,2.731,0,0,1,5.157,0H11.9a.916.916,0,0,1,0,1.831ZM4.579,1.832a.916.916,0,1,0,.916.916A.916.916,0,0,0,4.579,1.832Z",
    transform: "translate(0 0)",
    fill: "#e73758",
    stroke: "#fff",
    strokeWidth: 0.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.bf5c1269f710fec193450eed80ebeba5.svg";
export { ForwardRef as ReactComponent };